import React from "react";
import {RouteObject} from "react-router-dom";
import OrderSubcriptionLayout from "../../layout/OrderSubscriptionLayout/OrderSubcriptionLayout";

const OrderSubcriptionRoutes : RouteObject[] = [
    {
        path:'order',
        element: <OrderSubcriptionLayout/>
    }
]

export default OrderSubcriptionRoutes;
